import React from 'react';
import { DateTimePickerTemplate } from 'themes/components';

class DateTimePicker extends React.Component {
	render() {
		return <DateTimePickerTemplate {...this.props} />;
	}
}

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/core/components/forms/DateTimePicker.jsx